export const HOW_IT_WORKS_LINK = 'https://searchality.com/how-it-works-schools';
export const PRICING = 'https://searchality.com/pricing';
export const LEARN_MORE_LINK = 'https://searchality.com';
export const HOMEPAGE_LINK = 'https://searchality.com';
export const WEBSITE_INTEGRATION_MORE = 'https://searchality.com';
export const SEARCHALITY_CONTACT_MAIL = 'hello@searchality.com';
export const SEARCHALITY_CONTACT_MAIL_SUPPORT = 'support@searchality.com';
